import { Injectable } from '@angular/core';

export interface RecaptchaWidgetHandle {
	getToken(): string | null;
	reset(): void;
}

@Injectable({ providedIn: 'root' })
export class RecaptchaWidgetRegistry {
	private readonly widgets = new Set<RecaptchaWidgetHandle>();

	register(widget: RecaptchaWidgetHandle): () => void {
		this.widgets.add(widget);
		return () => {
			this.widgets.delete(widget);
		};
	}

	// ReCAPTCHA v2 tokens are single-use: Google consumes them on the first
	// verification, so the widget that produced the token must be solved
	// again before it can be used in another request.
	markTokenConsumed(token: string): void {
		this.widgets.forEach((widget) => {
			if (widget.getToken() === token) {
				widget.reset();
			}
		});
	}
}
